var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-by-unit-chart',{staticClass:"monthly-climate-sparkline-chart",attrs:{"data":_vm.processChartData(_vm.climateData),"provided-options":Object.assign({}, _vm.options),"height":70}})}
var staticRenderFns = []

export { render, staticRenderFns }